import { Network } from 'relay-runtime';
import { fetch } from '@atlassian/jira-relay-fetch/src/index.tsx';
import { subscribe } from '@atlassian/relay-subscription';
import { isSSR } from './constants.tsx';

export const getNetwork = () => {
	if (isSSR()) {
		Network.create(fetch);
	}
	return Network.create(fetch, subscribe);
};
